/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://ekotghowpvhl3g7hdeeh3nhyei.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "rest",
            "endpoint": "https://ako79tr4uf.execute-api.eu-west-2.amazonaws.com/devone",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:7c309729-ba37-4db5-b044-fc62409b2321",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_mg5LjAtOO",
    "aws_user_pools_web_client_id": "1qkd138setpi803vi8ef132gfj",
    "oauth": {
        "domain": "elias-dev1-main.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "openid",
            "profile"
        ],
        "redirectSignIn": "http://localhost:8000",
        "redirectSignOut": "http://localhost:8000",
        "responseType": "token"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "inspectionscontent133344-devone",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
